import { createContext, useContext, useState, useCallback } from 'react';

const UnsavedChangesContext = createContext(null);

export function UnsavedChangesProvider({ children }) {
  const [checkFunction, setCheckFunction] = useState(null);

  const registerCheck = useCallback((fn) => {
    setCheckFunction(() => fn);
  }, []);

  const unregisterCheck = useCallback(() => {
    setCheckFunction(null);
  }, []);

  const hasUnsavedChanges = useCallback(() => {
    if (!checkFunction) return false;
    try {
      return checkFunction();
    } catch (error) {
      console.error('Error checking unsaved changes:', error);
      return false;
    }
  }, [checkFunction]);

  return (
    <UnsavedChangesContext.Provider
      value={{
        registerCheck,
        unregisterCheck,
        hasUnsavedChanges,
      }}
    >
      {children}
    </UnsavedChangesContext.Provider>
  );
}

export function useUnsavedChanges() {
  const context = useContext(UnsavedChangesContext);
  if (!context) {
    throw new Error('useUnsavedChanges must be used within UnsavedChangesProvider');
  }
  return context;
}

